<template>
    <div class="module_page page_content" aria-label="create connection Page Content">
        <div class="row page-heading header">
            <div class="col-9 heading">
                <!--
                <span class="module_icon icon-stream"></span>
                <span class="ml-2"> My Quests </span>
                <span class="ml-3"> > </span>
                -->
                <span class="ml-3">
                    <span class="icon icon-job ace_sec_hd" role="heading" aria-level="1" :aria-label="careerIdea.title"></span> {{careerIdea.title}}
                </span>
                <template v-if="firstName || lastName">
                    <span class="ml-3"> > </span>
                    <span class="ml-2 icon ico-connection1" style="font-size: 32px; margin-top: 8px;"></span>
                </template>
                <span class="subhead_txt"> {{firstName}} {{lastName}} </span>
            </div>
            <div class="col-3 float-right px-0">
                <div class="submit btn-container">
                    <button class="btn btn-primary" @click="saveOrDone(true)" aria-label="done">done</button>
                    <button class="btn btn-primary" @click="saveOrDone(false)" aria-label="save">save</button>
                    <button class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
                </div>
            </div>
        </div>
		<div class="row page_fld_section">
			<div class="col-5">
                <div class="fld_label" id="firstName">First Name <sup>*</sup></div>
                <div class="fld_input">
                    <b-form-input v-model.trim="firstName" :state="firstNameState"
                        aria-labelledby="firstName" placeholder="First Name"
                        @blur="$v.firstName.$touch()"
                        aria-describedby="firstNameFeedback" v-focus>
                    </b-form-input>
                    <b-form-invalid-feedback id="firstNameFeedback">
                        First Name must not be empty
                    </b-form-invalid-feedback>
                </div>
            </div>
			<div class="col-1"></div>
			<div class="col-5">
                <div class="fld_label" id="lastName">Last Name <sup>*</sup></div>
                <div class="fld_input">
                    <b-form-input v-model.trim="lastName" :state="lastNameState"
                        aria-labelledby="lastName" placeholder="Last Name"
                        @blur="$v.lastName.$touch()"
                        aria-describedby="lastNameFeedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="lastNameFeedback">
                        Last Name must not be empty
                    </b-form-invalid-feedback>
                </div>
            </div>
		</div>

		<div class="row page_fld_section">
			<div class="col-5">
                <div class="fld_label" id="organization">Organization</div>
                <div class="fld_input">
                    <b-form-input v-model.trim="organization"
                        aria-labelledby="firstName" placeholder="Organization"
                        aria-describedby="organizationFeedback">
                    </b-form-input>
                </div>
            </div>
			<div class="col-1"></div>
			<div class="col-5">
                <div class="fld_label" id="lastName">Meeting Date</div>
                <div class="fld_input">
                    <datetime
                        type="date" v-model="meetingDate"
                        :format="{year: 'numeric', month: '2-digit', day: '2-digit'}" auto
                        :min-datetime="minDatetime" :week-start="7" input-style="width: 100%; height: 34px;">
                    </datetime>
                    <!--
					<span class="icon ico-dateRange"></span>
					-->
                </div>
            </div>
		</div>

        <div class="row page_fld_section">
			<div class="col-5">
                <div class="fld_label" id="nextStep">Next Step</div>
                <div class="fld_input">
                    <b-form-input :type="text" disabled value="Scheduled" />
                </div>
            </div>
			<div class="col-1"></div>
			<div class="col-5">
                <div class="fld_label" id="phone">Phone</div>
                <div class="fld_input">
                    <b-form-input :type="tel" v-model.trim="phone" :state="phoneState"
                        aria-labelledby="phone" placeholder="Phone"
                        @blur="$v.phone.$touch()"
                        aria-describedby="phoneFeedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="phoneFeedback">
                        Phone number must be valid
                    </b-form-invalid-feedback>
                </div>
            </div>
		</div>
		
		<div class="row page_fld_section">
			<div class="col-5">
                <div class="fld_label" id="email">Email</div>
                <div class="fld_input">
                    <b-form-input :type="email" v-model.email="email" :state="emailState"
                        aria-labelledby="email" placeholder="Email"
                        @blur="$v.email.$touch()"
                        aria-describedby="emailFeedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="emailFeedback">
                        Email must be valid
                    </b-form-invalid-feedback>
                </div>
            </div>
			
		</div>

        <div class="col-11 row mb-5 float-right" style="display:none">
            <div class="col-5 mr-3">
                <div class="mb-2" id="nextStep">Profile Pic</div>
                <div>
                    <span class="icon-user"></span>
                </div>
            </div>
            
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import Vuelidate from 'vuelidate'
  import {required, numeric, email} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'connection-create',
    props: ['careerIdeaId', 'connectionId'],
    components: {
      Datetime
    },
    data () {
      return {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        organization: null,
        meetingDate: null,
        ratingStatus: 0,
        conversationStatus: 0,
        minDatetime: DateTime.utc().toISO(),
        months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        careerIdea: {}
      }
    },

    validations: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      phone: {
        numeric
      },
      email: {
        email
      }
    },

    computed: {
      firstNameState () {
        return !this.$v.firstName.$error
      },

      lastNameState () {
        return !this.$v.lastName.$error
      },

      phoneState () {
        return !this.$v.phone.$error
      },

      emailState () {
        return !this.$v.email.$error
      }
    },

    mounted () {
      if (this.careerIdeaId) {
        this.populateCareerIdeaDetail()
      }
      if (this.connectionId) {
        this.populateConnectionDetail()
      }
    },

    methods: {
      ...mapActions([
        'loadCareerIdeaDetail',
        'createConnection',
        'loadConnectionDetail'
      ]),

      populateCareerIdeaDetail () {
        this.loadCareerIdeaDetail(this.careerIdeaId).then(res => {
          this.careerIdea = res
        })
      },

      populateConnectionDetail () {
        this.loadConnectionDetail(this.connectionId).then(res => {
          if (res) {
            this.firstName = res.firstName
            this.lastName = res.lastName
            this.email = res.email
            this.phone = res.phone
            this.organization = res.organization
            this.meetingDate = this.changeMillisToDate(res.meetingDate)
            this.ratingStatus = res.ratingStatus
            this.conversationStatus = res.conversationStatus
          }
        })
      },

      cancel () {
        return this.$router.push({name: 'connection', params: {careerIdeaId: this.careerIdeaId}})
      },

      saveOrDone (isDone) {
        this.$v.$touch()
        if (this.firstNameState && this.lastNameState && this.phoneState && this.emailState) {
          this.$refs.loadingModal.show()
          let data = {
            careerIdeaId: this.careerIdeaId,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
            organization: this.organization,
            meetingDate: this.changeDateToMillis(this.meetingDate),
            ratingStatus: this.ratingStatus,
            conversationStatus: this.conversationStatus
          }
          let message = 'Connection "' + this.firstName + ' ' + this.lastName + '" is created successfully.'
          if (this.connectionId) {
            data.uuid = this.connectionId
            message = 'Connection "' + this.firstName + ' ' + this.lastName + '" is updated successfully.'
          }
          this.createConnection(data).then(res => {
            this.$refs.loadingModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: message
            })
            if (isDone) {
              return this.$router.push({name: 'connection', params: {careerIdeaId: this.careerIdeaId}})
            } else {
              this.connectionId = res.uuid
              this.careerIdeaId = res.careerIdeaId
            }
          })
        }
      },

      changeDateToMillis (selected) {
        if (selected) {
          return DateTime.fromISO(selected).toMillis()
        }
        return null
      },

      changeMillisToDate (selected) {
        if (selected) {
          return DateTime.fromMillis(selected).toISO()
        }
        return null
      }
    }
  }
</script>

<style scoped>
    sup {
        color: red;
    }

    .header {
        background: #f7e5a8;
        margin-bottom: 75px;
        float: left;
        width: 100%;
        height:62px;
    }

    .heading {
        font-size: 22px;
        font-weight: 400;
        margin-top: 20px;
        padding-left: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/quest/components/ConnectionCreate.vue